__webpack_require__.p = "/laboratorios/";